import { msg } from "@lingui/core/macro";
import { createRoute, Outlet } from "@tanstack/solid-router";
import { appRoute } from "./route";
import { useSession } from "@/lib/auth";
import { TodoListView } from "@/features/todos/components/todo-list-view";
import { getTodosCountQuery, getTodosQuery } from "@listto/shared";
import { Star } from "@fleet/icons";

import type { PowerSyncDrizzleDB } from "@listto/powersync";

import { useI18n } from "@/providers/i18n-provider";

function ImportantPage() {
  const { t } = useI18n();
  const session = useSession();
  const { userId } = session;

  return (
    <>
      <TodoListView
        title={t(msg`Important`)}
        icon={Star}
        userId={userId()}
        queryFn={(db: PowerSyncDrizzleDB, uid: string, options) =>
          getTodosQuery(db, uid, { ...options, importantOnly: true })
        }
        countQueryFn={(db, uid) => getTodosCountQuery(db, uid, { importantOnly: true })}
        defaultAddTodoProps={{ important: true }}
        emptyMessage={t(msg`Mark tasks as important to see them here.`)}
        listId="important"
      />
      <Outlet />
    </>
  );
}

export const importantRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/important",
  component: ImportantPage,
});
